const translation = {
  toVerifiedTip: {
    coupon: 'exklusiver 100% Gutschein',
    end: 'für den Dify Professional Plan.',
    front: 'Sie sind jetzt berechtigt, den Status „Bildung verifiziert“ zu erhalten. Bitte geben Sie unten Ihre Bildungsinformationen ein, um den Prozess abzuschließen und eine Zu erhalten.',
  },
  form: {
    schoolName: {
      placeholder: 'Geben Sie den offiziellen, unabgekürzten Namen Ihrer Schule ein.',
      title: 'Ihr Schulname',
    },
    schoolRole: {
      option: {
        teacher: 'Lehrer',
        administrator: 'Schuladministrator',
        student: 'Schüler',
      },
      title: 'Ihre Schulrolle',
    },
    terms: {
      desc: {
        and: 'und',
        privacyPolicy: 'Datenschutzrichtlinie',
        termsOfService: 'Nutzungsbedingungen',
        end: '. Durch die Einreichung:',
        front: 'Ihre Informationen und die Nutzung des Status "Bildung bestätigt" unterliegen unseren',
      },
      option: {
        inSchool: 'Ich bestätige, dass ich an der angegebenen Einrichtung eingeschrieben oder angestellt bin. Dify kann einen Nachweis über die Einschreibung/Anstellung anfordern. Wenn ich meine Berechtigung falsch darstelle, stimme ich zu, alle Gebühren zu zahlen, die aufgrund meines Bildungsstatus ursprünglich erlassen wurden.',
        age: 'Ich bestätige, dass ich mindestens 18 Jahre alt bin.',
      },
      title: 'Allgemeine Geschäftsbedingungen',
    },
  },
  toVerified: 'Bildung überprüfen lassen',
  rejectTitle: 'Ihre Dify-Ausbildungsüberprüfung wurde abgelehnt.',
  currentSigned: 'DERZEIT ANGEMELDET ALS',
  submit: 'Einreichen',
  submitError: 'Die Formularübermittlung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.',
  rejectContent: 'Leider sind Sie nicht für den Status "Education Verified" berechtigt und können daher den exklusiven 100%-Gutschein für den Dify Professional Plan nicht erhalten, wenn Sie diese E-Mail-Adresse verwenden.',
  successContent: 'Wir haben einen 100% Rabattgutschein für den Dify Professional Plan auf Ihr Konto ausgestellt. Der Gutschein ist ein Jahr lang gültig, bitte nutzen Sie ihn innerhalb des Gültigkeitszeitraums.',
  learn: 'Erfahren Sie, wie Sie Ihre Ausbildung überprüfen lassen.',
  emailLabel: 'Ihre aktuelle E-Mail',
  successTitle: 'Sie haben die Dify-Ausbildung verifiziert',
}

export default translation
